import moment from 'moment'
import Urls from '@/router/urls'
import rules from '@/utils/rules'
import { mapActions, mapGetters } from 'vuex'
import { formatNumber } from '@/utils/number'

export default {
  data: () => ({
    rules,

    companyTypes: [
      'einzel',
      'gbr',
      'gmbh',
      'ug',
      'gmbhcokg',
      'kommandit',
      'genoss',
      'ag'
    ],

    salutations: [
      'Frau',
      'Herr',
      'Ohne',
    ],

    roles: [
      'Geschäftsführer',
      'Assistenz',
      'Prokurist',
      'Inhaber',
      'Mitarbeiter',
      'Ehegatte',
      'Kind',
      'Lebensgefährte',
    ],

    tableProps: {
      'no-data-text': 'Keine Daten vorhanden',
      'no-results-text': 'Keine Daten gefunden',
      'footer-props': {
        'items-per-page-options': [15, 5, 25, { text: 'Alle', value: -1 }],
        'items-per-page-text': 'Anzahl pro Seite'
      }
    },

    defaultPagination: {
      page: 1,
      itemsPerPage: -1
    },
  }),

  computed: {
    ...mapGetters([
      'agencies',
      'companies',
      'countries',
      'currentTabId',
      'isDebugMode',
      'isOutput',
      'isVertrag',
      'isStatus',
      'isConcept',
      'isSSO',
      'openGroups',
      'openSubSections',
      'selectedAgency',
      'selectedCompany',
      'showEmptyNotice',
      'showCustomerPref',
      'userTenantId',
      'isConceptEdit',
      'hasConcept',
    ]),
  },

  methods: {
    ...mapActions([
      'loadAgencies',
      'loadCompanies',
      'selectAgency',
      'selectCompany',
      'setIsLoading',
      'setShowEmptyNotice',
      'setShowCustomerPref',
      'setConceptEdit',
    ]),

    deleteConcept () {
      const id = this.$store.getters.consultationId
      if (!id) {
        return
      }

      return this.$axios
        .post(`${ Urls.Consultation(id) }delete_konzept/`)
        .then(() => {
          this.$store.dispatch('setHasConcept', false)
        })
        .catch(err => {
          this.$toast.error(err.message, 'Fehler')
        })
    },

    formatDateTime (value, format = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') {
      const date = moment(value)

      return date.isValid()
        ? date.format(format)
        : null
    },

    formatMoney (value, decimals = 2) {
      if (!value && value !== 0) {
        return ''
      }

      return `${ formatNumber(value, decimals) } €`
    },

    getDateFromOffset (fromDate, offset, unit = 'days', format = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') {
      const curDate = moment(fromDate)
      if (!curDate.isValid()) {
        return ''
      }

      const result = curDate.add(offset, unit)
      return result.isValid()
        ? result.format(format)
        : ''
    },

    getDebugInfo (field) {
      if (!field || !field.id) {
        return ''
      }

      let debugInfo = ''
      const showKeys = [
        'id', 'field_id', 'mandatory', 'hidden', 'display_field', 'type', 'sort_index', 'rules'
      ]

      showKeys.forEach(k => {
        if (field[k] !== null && field[k] !== undefined) {
          let v = field[k]

          if (k === 'hidden') {
            v = field.hidden_org
          } else if (k === 'rules') {
            v = field[k].join(', ')
          }

          debugInfo = `${ debugInfo }, "${ k }": ${ v }`
        }
      })

      return debugInfo.substring(2)
    },

    getElementTop (element) {
      if (!element) {
        return 0
      }

      const elTop = 0 // element.style.top
      let top = 0

      do {
        top += element.offsetTop || 0
        element = element.offsetParent
      } while (element)

      return elTop
        ? parseInt(elTop) + top
        : top
    },

    getValueKey (type) {
      const valueKey = {
        s: 'v_string',
        r: 'v_string',
        c: 'v_string',
        m: 'v_string',
        i: 'v_int',
        f: 'v_float',
        w: 'v_float',
        W: 'v_float',
        d: 'v_string',
        t: 'v_time',
        b: 'v_bool',
      }

      return valueKey[type] || ''
    },

    getFieldValue (field) {
      const k = this.getValueKey(field.type)
      return field[k] !== undefined
        ? field[k]
        : null
    },

    getFormattedValue (field) {
      if (field.type === 'w' || field.type === 'W') {
        return this.formatMoney(field.value, field.type === 'w' ? 2 : 0)
      }

      if (field.type === 't') {
        return this.formatDateTime(field.value, field.v_time_format)
      }

      if (field.type === 'i' || field.type === 'f') {
        if (field.styling && field.styling.thousands_separator === false) {
          return field.value
        } else {
          return formatNumber(field.value, field.type === 'f' ? 2 : 0)
        }
      }

      return field.value
    },

    getTranslatedItems (items, field = '') {
      return items
        .map(item => {
          if (field) {
            return {
              ...item,
              [field]: this.$t(item[field])
            }
          }

          return {
            id: item,
            text: this.$t(item)
          }
        })
    },

    gotoRoute (name, params = null) {
      if (!name) {
        return
      }
      if (name === 'analyse') {
        window.open('https://www.umfrageonline.com/c/znke7xjk', '_blank')
        return
      }
      const route = {
        name,
      }
      if (params) {
        route.params = params
      }
      this.$router.push(route)
    },

    isEmptyField (f) {
      return !f.hidden && f.sort_index !== 9998 && f.sort_index !== 9999 && (f.value === null || f.value === '')
    },

    isFormValid (ref) {
      const form_ = this.$refs[ref]
      return form_ && form_.validate()
    },

    resetForm (ref) {
      const form_ = this.$refs[ref]
      if (form_) {
        form_.resetValidation()
      }
    },

    searchFieldInCategory (id, categories, callback) {
      let found = null

      const findFiled = (fields) => {
        let field = null

        fields.forEach(f => {
          if (!field && f.id === id) {
            field = f
          }

          if (f.groups) {
            Object.keys(f.groups)
              .map(k => {
                if (!field) {
                  const index = (f.groups[k] || []).findIndex(f_ => f_.id === id)
                  if (index >= 0) {
                    field = f.groups[k][index]
                  }
                }
              })
          }
        })

        return field
      }

      categories.forEach((c, index) => {
        if (found) {
          return
        }

        found = findFiled(c.fields)
        if (found && callback) {
          callback(found, index)
        }

        Object.keys(c.buildings || {})
          .filter(k => !c.buildings[k].hidden)
          .forEach(k => {
            if (found) {
              return
            }

            found = findFiled(c.buildings[k].fields || [])
            if (found && callback) {
              callback(found, index)
            }
          })
      })

      return found
    },

    scrollToField (fieldId) {
      let element = document.getElementById(`dynamic-field-${ fieldId }`)
      if (element) {
        window.scrollTo({
          top: this.getElementTop(element) - 265,
          behavior: 'smooth'
        })
        return
      }

      element = document.getElementById(`dynamic-field-question-${ fieldId }`)
      if (element) {
        window.scrollTo({
          top: this.getElementTop(element) - 265,
          behavior: 'smooth'
        })
        return
      }

      element = document.getElementById(fieldId)
      if (element) {
        window.scrollTo({
          top: this.getElementTop(element) - 265,
          behavior: 'smooth'
        })
      }
    },

    alignGroupElements () {
      let elements = Array.from(document.getElementsByClassName('group-fields'))
      if (!elements.length) {
        return
      }
      elements.forEach((e, i) => {
        const rightEl = elements.find((el, ei) => e.id === el.id && i !== ei)
        if (rightEl) {
          if (e.clientHeight === 0 || rightEl.clientHeight === 0) {
            e.style.minHeight = 0
            rightEl.style.minHeight = 0
            return
          }
          if (e.clientHeight > rightEl.clientHeight) {
            rightEl.style.minHeight = `${ e.clientHeight }px`
          } else {
            e.style.minHeight = `${ rightEl.clientHeight }px`
          }
        }
      })

      elements = Array.from(document.getElementsByClassName('group-panel'))
      if (!elements.length) {
        return
      }
      elements.forEach((e, i) => {
        const rightEl = elements.find((el, ei) => e.id === el.id && i !== ei)
        if (rightEl) {
          if (!e.classList.contains('v-expansion-panel--active') && !rightEl.classList.contains('v-expansion-panel--active')) {
            e.style.minHeight = 0
            rightEl.style.minHeight = 0
          } else if (!rightEl.classList.contains('v-expansion-panel--active')) {
            e.style.minHeight = `${ e.lastChild.clientHeight }px`
            rightEl.style.minHeight = `${ e.lastChild.clientHeight }px`
          } else if (!e.classList.contains('v-expansion-panel--active')) {
            e.style.minHeight = `${ rightEl.lastChild.clientHeight }px`
            rightEl.style.minHeight = `${ rightEl.lastChild.clientHeight }px`
          } else {
            if (e.clientHeight > rightEl.clientHeight) {
              rightEl.style.minHeight = `${ e.clientHeight }px`
            } else {
              e.style.minHeight = `${ rightEl.clientHeight }px`
            }
          }

          // const elTop = this.getElementTop(e)
          // const rightElTop = this.getElementTop(rightEl)
          // console.log(elTop, rightElTop)
          // if (elTop > rightElTop) {
          //   const elPosTop = e.style.top ? parseInt(e.style.top) : 0
          //   // const rightElPosTop = rightEl.style.top ? parseInt(rightEl.style.top) : 0
          //   rightEl.style.top = `${ elTop - rightElTop }px`
          //   console.log(elTop - rightElTop, elPosTop - elTop + rightElTop)
          //   e.style.top = elPosTop ? `${ elPosTop - elTop + rightElTop }px` : 0
          // } else {
          //   const rightElPosTop = rightEl.style.top ? parseInt(rightEl.style.top) : 0
          //   e.style.top = `${ rightElTop - elTop }px`
          //   console.log(rightElTop - elTop, rightElPosTop - rightElTop + elTop)
          //   rightEl.style.top = rightElPosTop ? `${ rightElPosTop - rightElTop + elTop }px` : 0
          // }
        }
      })
    },

    resetGroupElements () {
      let elements = Array.from(document.getElementsByClassName('group-fields'))
      if (!elements.length) {
        return
      }
      elements.forEach(e => {
        e.style.minHeight = 0
      })

      elements = Array.from(document.getElementsByClassName('group-panel'))
      if (!elements.length) {
        return
      }
      elements.forEach(e => {
        e.style.minHeight = 0
        e.style.marginTop = 0
      })
    }
  }
}
